module.exports = __webpack_public_path__ + "img/cg.0dd27e12.svg";